import { FC } from 'react';
import { useSelector } from 'react-redux';
import CreateAccountLiefMan from 'assets/images/liefIcons/create-account-liefman.svg';
import RizaLogo from 'assets/images/logos/riza-large-logo-no-text.svg';
import { AppState } from 'types';
import classes from './Home.module.css';

const Home: FC = () => {
  const isAuthenticated = useSelector((state: AppState) => state.auth.isAuthenticated);
  return (
    <div className={classes.HomeOuterContainer}>
      <div className={classes.HomeInnerContainer}>
        {!isAuthenticated && (
          <div className={classes.CreateAccountCallout}>
            <img src={CreateAccountLiefMan} alt="create-account" />
            <p className={classes.CalloutText}>Create an account to get started</p>
          </div>
        )}
        <div className={classes.BodyContent}>
          <img src={RizaLogo} alt="Riza" className={classes.RizaLogo} />
          <div className={classes.BodyText}>
            <h1>Live better Grow stronger Together</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
